import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export const sendWishlist = (data: {
  wishlistId: string;
  entryIds: string[];
  salesPartnerCode: string;
  salesPartnerMessage: string;
}): Promise<Response> => {
  return occFetch(occUrl("/store-finder/sendWishlist"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response;
    }
  });
};
